const SCROLL_THRESHOLD_OVERLAY = 16;

/**
 * Toggle sticky header state on scroll (overlay / inner-hero / inner margin collapse).
 *
 * @return {void}
 */
export function initHeaderSticky() {
	const header = document.querySelector('[data-header]');

	if (!header) {
		return;
	}

	const body = document.body;
	const usesFixedSticky =
		body.classList.contains('header-layout-overlay') ||
		body.classList.contains('header-layout-inner-hero');

	const getThreshold = () => {
		if (usesFixedSticky) {
			return SCROLL_THRESHOLD_OVERLAY;
		}

		if (body.classList.contains('header-layout-inner')) {
			return 1;
		}

		return 1;
	};

	let ticking = false;

	const update = () => {
		ticking = false;
		const isSticky = window.scrollY >= getThreshold();
		header.classList.toggle('is-sticky', isSticky);
		body.classList.toggle('is-header-sticky', isSticky);
	};

	const onScroll = () => {
		if (ticking) {
			return;
		}

		ticking = true;
		window.requestAnimationFrame(update);
	};

	update();
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onScroll, { passive: true });
}
